import { observer } from 'mobx-react';
import React, { useEffect, useState, useRef } from 'react';
import {
    FlexDiv,
    Image,
    SpaceBetweenDiv,
} from '../../design-system/containers';
import { TextLabel, TextDefault } from '../../design-system/texts';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EmailAvatar from './email-avatar';
import EmailDetails from './emailDetails';
import { Tooltip } from '@mui/material';
import { resourcePath } from '../../../utils/helpers';

function EmailHeader({
    ui,
    t,
    userEmail,
    userName,
    fromName,
    fromEmail,
    subject,
    toExtraEmail,
    onShowDetails,
}) {
    const node = useRef();
    const [open, setOpen] = useState(false);
    const [openTooltip, setOpenTooltip] = useState(false);

    const handleClick = (e) => {
        if (node.current.contains(e.target)) {
            // inside click
            return;
        }
        // outside click
        setOpen(false);
    };

    const handleOpen = () => {
        onShowDetails();
        setOpen(!open);
        setOpenTooltip(false);
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClick);

        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);

    return (
        <FlexDiv column mb={16}>
            <SpaceBetweenDiv alignStart>
                <FlexDiv gap={8}>
                    <EmailAvatar ui={ui} mobileOnly />
                    <FlexDiv column gap>
                        <FlexDiv gap={4} alignCenter>
                            <TextDefault bold>{ui.email.from_name}</TextDefault>
                            <TextLabel lighter mobileOnly>
                                10:38
                            </TextLabel>
                        </FlexDiv>

                        <Tooltip
                            title={t('Click to show details')}
                            open={openTooltip}
                            onOpen={() => setOpenTooltip(true)}
                            onClose={() => setOpenTooltip(false)}
                        >
                            <TextLabel lighter alignCenter link>
                                {t('to me')}{' '}
                                <ArrowDropDownIcon
                                    fontSize="small"
                                    onClick={handleOpen}
                                />
                            </TextLabel>
                        </Tooltip>
                    </FlexDiv>
                </FlexDiv>
                <FlexDiv gap={4} alignCenter>
                    <TextLabel lighter desktopOnly>
                        10:38 {t('AM (0 minutes ago)')}
                    </TextLabel>
                    <Image
                        src={resourcePath(
                            '/static/img/assessment/icon/star_border_24px.svg'
                        )}
                        alt={t('Star')}
                        className="hover-details desktopOnly"
                    />
                    <Image
                        src={resourcePath(
                            '/static/img/assessment/icon/reply_24px.svg'
                        )}
                        alt={t('Reply')}
                    />
                    <Image
                        src={resourcePath(
                            '/static/img/assessment/icon/more_vert_24px.svg'
                        )}
                        alt={t('More')}
                    />
                </FlexDiv>
            </SpaceBetweenDiv>
            <EmailDetails
                userEmail={userEmail}
                userName={userName}
                fromName={fromName}
                fromEmail={fromEmail}
                subject={subject}
                toExtraEmail={toExtraEmail}
                node={node}
                open={open}
                t={t}
            />
        </FlexDiv>
    );
}

export default observer(EmailHeader);
